@let doc = document();
<button
  class="document-reference-card no-style"
  animate.enter="fly-in-from-top"
  [attr.aria-label]="('general.download' | translate) + doc.fileName"
  [matTooltip]="formatPages()"
  (click)="handleDownload()">
  <span class="document-reference-card__filename">{{ doc.fileName }}</span>
</button>
